import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Mailto from 'react-mailto';
import scrollToComponent from 'react-scroll-to-component';

import Slider from "react-slick";

import AntiModal from '../../common/modal/AntiModal';
import {TeamModalContainer} from './TeamModal';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../utils/itemValidation';
import {displayPhone} from '../../../utils/formatting';

import * as stores from '../../../constants/stores';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class Watch extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		
		let initSlickSettings = {
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    };

		this.state = {
			store: stores.ALL[this.props.route.store_id],
			activePromo: false,
			holidayHours: false,
			hoursNotice: false,
			biosOpen: false,
			openModal: false,
			selectedMember: null,
			slickSettings: initSlickSettings,

			contactName: '',
			contactEmail: '',
			contactSubject: '',
			contactMessage: '',

			errorContactName: false,
			errorContactEmail: false,
			errorContactSubject: false,
			errorContactMessage: false,
		};
	}

	componentWillMount() {
		document.title = this.state.store.title;
    document.getElementsByTagName("META")[7].content = this.state.store.description;
	}

	componentDidMount() {
    // setTimeout(() => {
    // 	this.props.commonNotify();
    // }, 1000);
  }

	scrollDown() {
    scrollToComponent(this.biosSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

	facebookNav() {
		let win = window.open(this.state.store.facebookUrl, '_blank');
    win.focus();
	}

	instagramNav() {
		let win = window.open(this.state.store.instagramUrl, '_blank');
    win.focus();
	}

  userNav(page) {
    // this.context.router.push('/' + page);
    window.location.href = '/' + page;
  }

  fetchHours() {
  	return this.state.holidayHours ? this.state.store.hours.holiday : this.state.store.hours.default;
  }

  toggleBios() {
  	this.setState({
  		biosOpen : !this.state.biosOpen,
  	});
  }

  bestsellerImg(img) {
  	return {backgroundImage:  'url(/img/store/watch/bestsellers/' + img + ')'} 
  }

  openContactModal(member) {
  	this.setState({
      openModal: true,
    });
  }

  closeContactModal() {
    this.setState({
      openModal: false,
    });
  }

  scrollTop() {
    scrollToComponent(this.topSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollBest() {
    scrollToComponent(this.bestSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollAbout() {
    scrollToComponent(this.aboutSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollBrands() {
    scrollToComponent(this.designersSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollService() {
    scrollToComponent(this.serviceSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollContact() {
    scrollToComponent(this.contactSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  changeName(evt) {
    this.setState({ contactName: evt.target.value }, () => {
      if(this.state.errorContactName && !nameValidation(this.state.contactName)) {
        this.setState({ errorContactName: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ contactEmail: evt.target.value }, () => {
      if(this.state.errorContactEmail && !emailValidation(this.state.contactEmail)) {
        this.setState({ errorContactEmail: null });
      }
    });
  }

  changeSubject(evt) {
    this.setState({ contactSubject: evt.target.value }, () => {
      if(this.state.errorContactSubject && !locationValidation(this.state.contactSubject)) {
        this.setState({ errorContactSubject: null });
      }
    });
  }

  changeMessage(evt) {
    this.setState({ contactMessage: evt.target.value }, () => {
      if(this.state.errorContactMessage && !messageTextValidation(this.state.contactMessage)) {
        this.setState({ errorContactMessage: null });
      }
    });
  }

  validateAll() {

    let nameError = nameValidation(this.state.contactName) !== null;
    let emailError = emailValidation(this.state.contactEmail) !== null;
    let subjectError = locationValidation(this.state.contactSubject) !== null;
    let messageError = messageTextValidation(this.state.contactMessage) !== null;
    
    this.setState({
      errorContactName: nameError,
			errorContactEmail: emailError,
			errorContactSubject: subjectError,
			errorContactMessage: messageError,
    });

    return !nameError && !emailError && !subjectError && !messageError;
  }

  contactRequest() {
  	if(this.validateAll()) {

  		let watchData = {
  			"full_name": this.state.contactName,
  			"email": this.state.contactEmail,
  			"subject": this.state.contactSubject,
  			"message": this.state.contactMessage,
  		}

  		this.props.commonWatchRequest(watchData);
      this.props.commonAlert('We have received your submission and will be in touch shortly.', 'Continue');
      this.closeContactModal();
      this.setState({
      	contactName: '',
				contactEmail: '',
				contactSubject: '',
				contactMessage: '',

				errorContactName: false,
				errorContactEmail: false,
				errorContactSubject: false,
				errorContactMessage: false,
      }, () => {
      	console.log(this.state);
      });
    }
  }

	render() {

		return <div className='Watch'>
			<div className='bannerSection' ref={(div) => { this.topSection = div; }}>
				<img src={'https://ddw2.diamondsdirect.com/img/store/watch/hublot_header.jpg'} />
			</div>
			<div className={'infoSection watchInfo'}>
				<div className='tabbedNavigation'>
					<div className='singleTab' onClick={::this.scrollBest}>Best&nbsp;Sellers</div>
					<div className='singleTab' onClick={::this.scrollAbout}>About Us</div>
					<div className='singleTab' onClick={::this.scrollBrands}>Brands</div>
					<div className='singleTab' onClick={::this.scrollService}>Service</div>
					<div className='singleTab' onClick={::this.scrollContact}>Contact</div>
				</div>
				<div className='infoTitle'>Our Designer &amp; Luxury Brand Watches</div>
				<div className='infoDescriptionWrapper'>
					<div className='infoDescriptionP'>Timepieces are one of the few items you wear on a daily basis, and it reflects your uniqueness. Here at Diamonds Direct, we offer a range of luxury watches that conform to your identity, personality, and lifestyle. No matter what you want to convey with your watch, our team will work with you to select the right luxury watch suited to your liking. Our watch styles range from classic, to sporty and rugged, and even ultra-modern and trendy. All of the watches we carry are meticulously chosen with form, function, luxury, and style in mind.</div>
				</div>
				<div className='infoRowWrapper locationHoursParent'>
					<div className={'infoRow locationHoursRow'} style={{marginBottom: '15px'}}>
						<div className='locationWrapper'>
							<div className='locationTitle'>Location</div>
							<div className='locationBody'>
								<div className='locationBodyRow'>{this.state.store.address.line1}</div>
								<div className='locationBodyRow'>{this.state.store.address.line2}</div>
							</div>
						</div>
						<div className='hoursWrapper'>
							<div className='hoursTitle'>Hours</div>
							<div className='hoursBody'>
								<div>
									{this.fetchHours().map((hour, i) => {
										return <div className='hoursBodyRow' key={i}>{hour.days}: {hour.hours}</div>;
									})}
								</div>
								<div>
									{this.state.hoursNotice ?
										<div className='hoursBodyRow hoursNotice'>{this.state.store.hours.notice}</div> :
										null
									}
								</div>
							</div>
						</div>
					</div>
					<div className='infoRow' style={{marginBottom: '50px'}}>
						<div className='phoneWrapper'>
							<a href={'tel:' + this.state.store.phone}>
								<div className='phoneIcon'></div>
								<div className='phoneValue'>{displayPhone(this.state.store.phone)}</div>
							</a>
						</div>
						<div className='emailWrapper'>
							<div className='emailIcon'></div>
							<div className='emailValue'>
								<Mailto email={this.state.store.email}>{this.state.store.email}</Mailto>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='bestsellerSection' ref={(div) => { this.bestSection = div; }}>
				<div className='bestTitle'>{this.state.store.bestsellersNew.title}</div>
				<div className='bestItems'>
					<div className={'bestLHS'}>
						<div className='largeItemWrapper'>
							<div className='largeImg' style={this.bestsellerImg(this.state.store.bestsellersNew.items.primary[0].image)}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>{this.state.store.bestsellersNew.items.primary[0].title}</div>
								<div className='itemLabelPrice'>{this.state.store.bestsellersNew.items.primary[0].subtitle}</div>
							</div>
						</div>
					</div>
					<div className={'bestRHS'}>
						<div className='itemGridWrapper'>
							<div className='smallItemRow'>
								<div className='smallItemWrapper'>
									<div className='smallImg' style={this.bestsellerImg(this.state.store.bestsellersNew.items.secondary[0].image)}></div>
									<div className='itemLabel'>
										<div className='itemLabelName'>{this.state.store.bestsellersNew.items.secondary[0].title}</div>
										<div className='itemLabelPrice'>{this.state.store.bestsellersNew.items.secondary[0].subtitle}</div>
									</div>
								</div>
								<div className='smallItemWrapper'>
									<div className='smallImg' style={this.bestsellerImg(this.state.store.bestsellersNew.items.secondary[1].image)}></div>
									<div className='itemLabel'>
										<div className='itemLabelName'>{this.state.store.bestsellersNew.items.secondary[1].title}</div>
										<div className='itemLabelPrice'>{this.state.store.bestsellersNew.items.secondary[1].subtitle}</div>
									</div>
								</div>
							</div>
							<div className='smallItemRow'>
								<div className='smallItemWrapper'>
									<div className='smallImg' style={this.bestsellerImg(this.state.store.bestsellersNew.items.secondary[2].image)}></div>
									<div className='itemLabel'>
										<div className='itemLabelName'>{this.state.store.bestsellersNew.items.secondary[2].title}</div>
										<div className='itemLabelPrice'>{this.state.store.bestsellersNew.items.secondary[2].subtitle}</div>
									</div>
								</div>
								<div className='smallItemWrapper'>
									<div className='smallImg' style={this.bestsellerImg(this.state.store.bestsellersNew.items.secondary[3].image)}></div>
									<div className='itemLabel'>
										<div className='itemLabelName'>{this.state.store.bestsellersNew.items.secondary[3].title}</div>
										<div className='itemLabelPrice'>{this.state.store.bestsellersNew.items.secondary[3].subtitle}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={'bestMobile mobileOnly'}>
						<div className='mobileItemWrapper'>
							<div className='mobileImg' style={this.bestsellerImg(this.state.store.bestsellersNew.items.primary[0].image)}></div>
							<div className='itemLabel'>
								<div className='itemLabelName'>{this.state.store.bestsellersNew.items.primary[0].title}</div>
								<div className='itemLabelPrice'>{this.state.store.bestsellersNew.items.primary[0].subtitle}</div>
							</div>
						</div>
						{this.state.store.bestsellersNew.items.secondary.map((item, i) => {
							return <div className='mobileItemWrapper' key={i}>
								<div className='mobileImg' style={this.bestsellerImg(item.image)}></div>
								<div className='itemLabel'>
									<div className='itemLabelName'>{item.title}</div>
									<div className='itemLabelPrice'>{item.subtitle}</div>
								</div>
							</div>
						})}
					</div>
				</div>
			</div>
			<div className='aboutSection' ref={(div) => { this.aboutSection = div; }}>
				<div className='infoTitle'>About Us</div>
				<div className='infoDescriptionWrapper'>
					<div className='infoDescriptionP'>For 20 years, Diamonds Direct has provided the highest quality diamonds and jewelry to clients across the United States. But we were missing a crucial aspect of the business: a luxury timepiece boutique.</div>
					<div className='infoDescriptionP'>So, in 2014, we launched the Diamonds Direct Watch boutique. We didn't want to carry the same brands as anyone else in the area so we looked for brands typically sold in New York on Fifth Ave or on Rodeo Drive in California and brought them to Charlotte. Our team regularly travels to the heart of watchmaking - Switzerland - to hand select the finest timepieces at the best value.</div>
					<div className='infoDescriptionP'>Want to learn more about our watches? Stop by and see us. Our comfortable no-pressure environment features relaxing couches, fine cigars, sports on TV, and of course, high-quality watches.</div>
				</div>
			</div>
			<div className='designersSection' ref={(div) => { this.designersSection = div; }}>
				<div className='bestTitle'>Our Brands</div>
				<div className='brandsWrapper'>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/hublot_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/frankmuller_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/blancpain_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/zenith_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/lacroix_logo.svg' />
					</div>
					<div className={'brandsElement'}>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/ernst_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/shorokhoff_logo.png' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/perrelet_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/bedat_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/giorgio_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/waldan_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/junghans_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/brm_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/alpina_logo.svg' />
					</div>
					<div className='brandsElement'>
						<img src='https://ddw2.diamondsdirect.com/img/store/watch/logos/graham_logo.png' />
					</div>
				</div>
			</div>
			<div className='serviceSection' ref={(div) => { this.serviceSection = div; }}>
				<div className='infoTitle'>Service</div>
				<div className='infoDescriptionWrapper'>
					<div className='infoDescriptionP'>At the Diamonds Direct Watch Boutique, we pride ourselves on service. This doesn't just mean providing first class service when you purchase a new timepiece but also taking care of your existing watches. From batteries to vintage watch repair, our trained experts will guide you through the process flawlessly and will have your watches running like new. Feel free to call or stop by and ask any of our experts for an estimate or assistance.</div>
				</div>
				<div className='backTopWrapper'>
					<div className='backTopLink' onClick={::this.scrollTop}>
						<div className='backLabel'>Back to Top</div>
						<div className='backArrow'>
							<img src='https://ddw2.diamondsdirect.com/img/store/watch/up_arrow.svg' />
						</div>
					</div>
				</div>
			</div>
			<div className='contactSection' ref={(div) => { this.contactSection = div; }}>
				<div className='bestTitle'>Contact</div>
				<div className='contactP'>
					Have further questions? Need more information? Feel free to <span className='contactLink' onClick={::this.openContactModal}>contact us!</span>
				</div>
			</div>
			<AntiModal 
        open={this.state.openModal} 
        closeMethod={::this.closeContactModal}
        resize={this.props.common.modalResize}
        theme={'teamBio'}>
        <div className='contactModalWrapper'>
        	<div className='closeIcon' onClick={::this.closeContactModal}>
		        <div className='closeX'>&times;</div>
		      </div>
		      <div className='requestTitle'>Contact Us</div>
		      <div className='requestBr'>
		        <img src='https://ddw2.diamondsdirect.com/img/icons/lines/iconline_thin.svg' />
		      </div>
		      <div className='watchFormWrapper'>
		      	<div className={'inputWrapper halfWidth'}>
		          <div className='inputLabel'>Your Name*:</div>
		          <input 
		          	className={this.state.errorContactName ? 'inputError' : 'inputNoError'} 
		          	value={this.state.contactName}
		          	onChange={::this.changeName}
		          	type='text' />
		        </div>
		        <div className={'inputWrapper halfWidth secondInput'}>
		          <div className='inputLabel'>Email*:</div>
		          <input 
		          	className={this.state.errorContactEmail ? 'inputError' : 'inputNoError'} 
		          	value={this.state.contactEmail}
		          	onChange={::this.changeEmail}
		          	type='email' />
		        </div>
		        <div className={'inputWrapper fullWidth'}>
		          <div className='inputLabel'>Subject*:</div>
		          <input 
		          	className={this.state.errorContactSubject ? 'inputError' : 'inputNoError'} 
		          	value={this.state.contactSubject}
		          	onChange={::this.changeSubject}
		          	type='text' />
		        </div>
		        <div className={'inputWrapper fullWidth'}>
		          <div className='inputLabel'>How can we help you?*:</div>
		          <textarea 
		          	className={this.state.errorContactMessage ? 'inputError' : 'inputNoError'}
		          	value={this.state.contactMessage}
		          	onChange={::this.changeMessage}></textarea>
		        </div>


		      </div>
		      <div className='submitWrapper'>
		        <div className={'submitButton actionButton'} onClick={::this.contactRequest}>Contact Us</div>
		      </div>
        </div>
      </AntiModal>
		</div>;
	}
}
export default Watch;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const WatchContainer = connect(
  mapStateToProps,
  allActionCreators
)(Watch);


// WEBPACK FOOTER //
// ./src/components/views/store/Watch.jsx